import React from "react";
import "./Css/Herosection.css";
import bgImage from "./Images/background.jpg"; 
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();
  return (
    <section
      className="hero"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="hero-overlay">
        <div className="hero-content">
          <h1>

             “ ग्रामपंचायत  तासगांव, आपला अभिमान ”    <br />आता डिजिटल स्वरूपात
        
          </h1>
         <p>
  आपल्या गावाची परंपरा, विकास आणि लोकसेवा — आता आधुनिक <br /> डिजिटल माध्यमातून सर्वांसाठी खुली.
</p>

          <div className="hero-buttons">
            <button className="primary-btn" onClick={() => navigate("/locationinfo")}>गावाची माहिती पाहा</button>
 <button 
      className="secondary-btn" 
      onClick={() => navigate("/contact")}
    >
      आमच्याशी संपर्क साधा
    </button>          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
